export default "__VITE_ASSET__BJzZJaxB__"